import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 600,
	height: 359,
	viewBox: "0 0 600 359",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M402.707 268.076c-24.331 29.863-61.423 48.936-102.973 48.936-43.845 0-82.734-21.245-106.886-53.985m235.709-46.665a131.8 131.8 0 0 1-14.35 35.19",
				stroke: "#4E86F3",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m191.012 292.098.844-30.369 28.64 1.656m-23.207-162.461c24.331-29.864 61.422-48.937 102.973-48.937 43.845 0 82.734 21.245 106.886 53.985m-235.699 46.665a131.9 131.9 0 0 1 14.35-35.19",
				stroke: "#4E86F3",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m408.985 76.902-.844 30.37-28.641-1.656",
				stroke: "#4E86F3",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M298.287 151.983c25.471 0 46.119-6.159 46.119-13.757s-20.648-13.756-46.119-13.756-46.119 6.159-46.119 13.756 20.648 13.757 46.119 13.757Z",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M311.614 167.515c-3.962.327-9.017.585-13.327.585-25.473 0-46.119-6.159-46.119-13.756v-16.246m92.249.138v16.108c0 2.35-1.976 4.562-5.472 6.506",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M292.487 168.03c-3.992.338-10.874.625-15.224.625-25.472 0-46.118-6.159-46.118-13.756 0-4.811 8.282-9.046 20.834-11.505",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M296.24 183.562c-5.79.783-12.215 1.22-18.988 1.22-25.473 0-46.119-6.159-46.119-13.757v-16.246",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M291.771 200.722c-4.569.446-9.445.694-14.519.694-25.473 0-46.119-6.159-46.119-13.757 0-2.985 3.198-5.752 8.62-8.013",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M291.484 216.878c-4.478.437-9.265.665-14.221.665-25.472 0-46.118-6.16-46.118-13.757V187.54m60.617 13.369c-22.652-.873-40.16-6.645-40.16-13.637v-5.029",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.556 249.122c24.489 0 44.341-19.827 44.341-44.284 0-24.458-19.852-44.285-44.341-44.285s-44.341 19.827-44.341 44.285 19.852 44.284 44.341 44.284Z",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M358.321 226.837c12.175-12.556 11.853-32.593-.72-44.752-12.573-12.16-32.635-11.838-44.81.718-12.175 12.557-11.853 32.593.72 44.753 12.572 12.16 32.634 11.838 44.81-.719Z",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M343.851 199.154v-.189c0-3.243-3.715-5.871-8.303-5.871s-8.302 2.628-8.302 5.871 3.774 5.168 8.302 5.872c5.701.893 8.303 2.668 8.303 5.862s-3.715 5.871-8.303 5.871-8.302-2.628-8.302-5.871m5.043-22.803v5.188m6.523-5.188v5.188m-6.523 23.516v5.187m6.523-5.187v5.187",
				stroke: "#679",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m224.413 147.481-12.702-7.578m21.46-1.825-8.273-12.18m-4.627 34.179-14.658-1.517",
				stroke: "#4E86F3",
				strokeWidth: 3,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M372.667 246.078c8.918 0 16.148-6.999 16.148-15.631s-7.23-15.632-16.148-15.632-16.147 6.999-16.147 15.632 7.229 15.631 16.147 15.631",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M372.072 208.686c-12.314 0-22.314 9.987-22.314 22.286 0 12.298 10 22.286 22.314 22.286s22.315-9.978 22.315-22.286-9.99-22.286-22.315-22.286m-1.44 33.85-11.072-10.751 2.919-2.995 7.558 7.339 11.39-16.107 3.417 2.41z",
				fill: "#4E86F3"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M170 50.5h260v268H170z"
		})
	}) })]
});
export default SvgCreditSuccess;
